export const getLastName = (fullName = ""): string => {
    let lastName = "";
    const names = fullName.trim().split(" ");

    if (names.length > 1) {
        names.shift();
        lastName = names.join(" ");
    }

    return lastName || ".";
};
